module.exports = __webpack_public_path__ + "static/media/landingPageVideoSecondTop.8e1d867d.png";